import React from 'react';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { MButtonProps } from '../MButton/MButton.types';
import { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';

export enum MHighlightIconAlignment {
  Centered = 'Centered',
  Left = 'Left',
}

export type MHighlightIconProps = {
  alignment?: MHighlightIconAlignment;
  aAccentLine?: AAccentLineProps;
  aIcon: AIconProps;
  aSubheader: ASubheaderProps;
  aBody?: ABodyProps;
  showCTA?: boolean;
  mButton?: MButtonProps<React.ElementType<HTMLButtonElement | HTMLAnchorElement>>;
};
